export default {
  ProcessTitle: 'Vật tư, công cụ dụng cụ',

  ProcessItem: {
    Inward: 'Nhập kho',
    Outward: 'Xuất kho',
    CreateDeclareTable: 'Báo cáo tồn kho',
    Increment: 'Ghi tăng',
    Decrement: 'Ghi giảm',
    ToolsLedger: 'Sổ theo dõi CCDC',

    InventoryItem: 'Vật tư',
    Tools: 'Công cụ dụng cụ',
    Stock: 'Kho',
    AccountingObject: 'Đối tượng',
    Employee: 'Cán bộ',
    Department: 'Phòng ban',

    Report: 'Báo cáo',
    ViewAllReports: 'Xem tất cả báo cáo',
  },

  ProcessCommand: {
    INInwardDetail: 'INInwardDetail',
    INInwardList: 'INInwardList',
    INInward: 'INInward',
    INOutwardDetail: 'INOutwardDetail',
    INOutwardList: 'INOutwardList',
    SuIncrementDetail: 'ToolIncrementDetail',
    SUIncrementList: 'SUIncrementList',
    SUDecrementDetail: 'SUDecrementDetail',
    SUDecrementList: 'SUDecrementList',
    Inventory: 'inventory',
    EquipmentInventoryItem: 'equipmentinventoryitem',
    Stock: 'stock',
    AccountingObjectMasterList: 'accountingobjectmasterlist',
    AccountingObject: 'accountingobject',
    Department: 'department',
    FixedAsset: 'fixedAsset',
    InventoryInwardCashDetail: 'InventoryInwardCashDetail',
    InventoryInwardDepositDetail: 'InventoryInwardDepositDetail',
    ReportParamS32H: 'ReportParamS32H',
  },

  ProcessTabKey: {
    INInward: 'ininward',
    SUDecrement: 'sudecrement',
  },

  ProcessTextCommand: {
    INInwardInventoryInwardCash: 'Nhập mua bằng tiền mặt',
    INInwardInventoryInwardDeposit: 'Nhập mua bằng tiền gửi',
    INInwardINInward: 'Nhập khác',
    Report: 'Tổng hợp dự toán',
    INInwardList: 'Danh sách Phiếu nhập kho',
    INOutwardDetail: 'Phiếu xuất kho',
    INOutwardList: 'Danh sách Phiếu xuất kho',
    SuIncrementDetail: 'Phiếu ghi tăng',
    SUIncrementList: 'Danh sách Phiếu ghi tăng',
    SUDecrementDetail: 'Phiếu ghi giảm',
    SUDecrementList: 'Danh sách Phiếu ghi giảm',
  },

  ReportItem: {
    Report01_a:
      'Mẫu số 01a-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân hàng bằng hình thức rút dự toán tại Kho bạc nhà nước',
    Report01: 'Mẫu số 01-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân sách tại Kho bạc nhà nước',
    Report02_a:
      'Mẫu số 02a-SDKP/ĐVDT: Bảng đối chiếu tình hình sử dụng kinh phí ngân sách bằng hình thức rút dự toán tại Kho bạc nhà nước',
    Report02: 'Mẫu số 02-SDKP/ĐVDT: Bảng đối chiếu tình hình sử dụng kinh phí ngân sách tại Kho bạc nhà nước',
  },
};
